import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { ArrowLeft } from 'components/icons';
import { Reference } from 'types/reference';
import Markdown from '../../markdown';

export interface ContentItem {
  subTitle?: string;
  richText?: string;
  ctaContentText?: string;
  ctaContentLink?: Reference;
}

interface Props {
  items: ContentItem[];
}

const TextOnlyBannerContent: React.FC<Props> = ({ items }) => {
  return (
    <div data-testid="ctr-text-only-banner-markdown-content" data-ffid="ctr-text-only-banner-markdown-content">
      {items.map((item, index) => {
        const headingId = `section-subtitle-${index}`;
        const linkId = `section-cta-${index}`;
        return (
          <div key={item.subTitle} className="mb-24 border-b border-[#ebebeb]">
            {item.subTitle && (
              <h3
                id={headingId}
                data-testid={`lbl-text-only-banner-markdown-content-sub-title-${index}`}
                data-ffid={`lbl-text-only-banner-markdown-content-sub-title-${index}`}
                className="mb-16 text-16 font-normal text-[#5c5c5c] lg:text-28"
              >
                {item.subTitle}
              </h3>
            )}
            { item.richText && (
              <div
                data-testid={`ctr-text-only-banner-markdown-content-section-${index}`}
                data-ffid={`ctr-text-only-banner-markdown-content-section-${index}`}
              >
                <Markdown
                  markdown={item.richText}
                  className="prose-a:text-underline prose max-w-none prose-p:w-full prose-p:text-left prose-p:text-14 prose-p:text-[#5C5C5C] prose-a:font-normal prose-a:text-[#0B57D0] prose-a:hover:text-[#0B57D0] prose-ul:list-none prose-ul:pl-10 prose-li:relative prose-li:pl-15 prose-li:text-14 prose-li:before:absolute prose-li:before:left-0 prose-li:before:top-12 prose-li:before:size-4 prose-li:before:rounded-full prose-li:before:bg-[#5c5c5c] prose-p:lg:text-16 prose-ul:lg:pl-20 prose-li:lg:text-16"
                />
              </div>
            )}
            {item.ctaContentLink && item.ctaContentText && (
              <Link
                data-ffid="lnk-text-only-banner-cta-link"
                className="text-14 text-[#0B57D0] lg:text-16"
                link={item.ctaContentLink}
                aria-labelledby={`${linkId} ${headingId}`}
              >
                <span className="my-16 flex items-center gap-10" id={linkId}>
                  {item.ctaContentText} <ArrowLeft className="rotate-180" dimension={16} />
                </span>
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TextOnlyBannerContent;
